export default {
  isAdmin: function () {
    return this.$store.state.app.session.roles?.includes('ROLE_ADMIN')
  },
}
